import { AnalyticsEvent } from '../models';

export class RewardsLinkClickedEvent implements AnalyticsEvent {
    name = 'RewardsLinkClickedEvent';

    constructor(public readonly pageName: string, public readonly linkName: string) {}
}